/* eslint-disable camelcase */
import Axios from 'axios'
import globalConfig from '../config'

export const venueService = {
  getOneVenue: async (idVenue) => {
    const { data } = await Axios.get(`${globalConfig.url}/venues/${idVenue}`)
    return data
  },
  getAllVenuesPublic: async () => {
    const { data } = await Axios.get(`${globalConfig.url}/venues?esta_activo=1`)
    return data
  }
}
